import React, { useEffect } from 'react';
import { g as getScrollbarWidth } from './index-0662fd70.js';
import { s as styled } from './styled-112a8bd0.js';
import { O as Overlay } from './Overlay-98261df8.js';
import { __rest } from 'tslib';

const Backdrop = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: -1000;
`;
const sizeMaps = {
    sm: '400px',
    md: '700px',
    lg: '960px',
};
const ModalContent = styled.div(({ theme, size, maxHeight, borderRadius }) => `
  background-color: ${theme.colors.white};
  display: flex;
  flex-direction: column;
  width: ${sizeMaps[size]};
  border-radius: ${borderRadius ? borderRadius : theme.borderRadius};
  max-height: ${maxHeight ? maxHeight : `90%`};
  z-index: 1060;
  position: relative;
  overflow-y: auto;
`);
const Modal = ({ show, onHide, children, className, size = 'md', maxHeight, borderRadius, }) => {
    useEffect(() => {
        if (typeof document !== 'undefined') {
            if (show) {
                document.body.style.overflow = 'hidden';
                document.body.style.paddingRight = `${getScrollbarWidth()}px`;
            }
        }
        return () => {
            document.body.style.overflow = 'unset';
            document.body.style.paddingRight = 'unset';
        };
    }, [show]);
    if (!show)
        return null;
    return (React.createElement(Overlay, { show: show, onEscPressed: onHide },
        React.createElement(Backdrop, { onClick: onHide }),
        React.createElement(ModalContent, { className: className, size: size, borderRadius: borderRadius, maxHeight: maxHeight }, children)));
};

const Wrapper$2 = styled.div `
  padding: 1rem;
  text-align: center;
  .title {
    margin-bottom: 0;
  }
`;
const ModalHeader = ({ children, className, }) => (React.createElement(Wrapper$2, { className: className },
    React.createElement("h5", { className: "title" }, children)));

const ModalBody = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return React.createElement(Wrapper$1, Object.assign({}, props), children);
};
const Wrapper$1 = styled.div `
  flex: 1 1 auto;
  padding: 0.5rem 2rem;
  position: relative;
`;

const ModalFooter = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return React.createElement(Wrapper, Object.assign({}, props), children);
};
const Wrapper = styled.div `
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export { Modal as M, ModalHeader as a, ModalBody as b, ModalFooter as c };
